import $ from 'jquery';

import scrollToSrc from './vendor/jquery.scrollto.js?raw';
import localScrollSrc from './vendor/jquery.localscroll.js?raw';
import drawerSrc from './vendor/jquery.drawer.js?raw';
import backstretchSrc from './vendor/jquery.backstretch.js?raw';
import wowSrc from './vendor/wow.js?raw';
import iscrollSrc from './vendor/iscroll.js?raw';

/**
 * Each vendored UMD script below is executed with an isolated, empty `module`
 * object and no `require`/`define` resolution, so it always takes its
 * plain-browser-global branch instead of a CommonJS branch that would try to
 * resolve `require("jquery")` against Vite's bundle graph. Running through
 * `Function` also keeps each script's own top-level `this` bound to `window`,
 * matching how they behaved as separately-loaded classic scripts before.
 * @see https://github.com/vitejs/vite/discussions/3744
 */
function runVendorScript(src) {
	new Function('module', 'require', 'window', 'jQuery', src).call(
		window,
		{},
		() => $,
		window,
		$
	);
}

runVendorScript(scrollToSrc);
runVendorScript(localScrollSrc);
runVendorScript(drawerSrc);
runVendorScript(backstretchSrc);
runVendorScript(wowSrc);
runVendorScript(iscrollSrc);

jQuery(function ($) {
	// Make sure JS class is added.
	function sm_body_class_js() {
		$(document).ready(function () {
			$('body').addClass('js');
		});
	}

	// Run on page scroll.
	function sm_site_header() {
		$(window).on('scroll', function () {
			if ($(document).scrollTop() > 50) {
				$('body').addClass('shadow');
			} else {
				$('body').removeClass('shadow');
			}
		});
	}

	// Drawer.js Menu
	function sm_drawer_menu() {
		$('.drawer').drawer();
	}

	// Toogle drawer-nav with certain links
	function sm_drawer_nav_toggle() {
		$('.front-page .drawer-nav .difference').click(function (event) {
			$('.drawer').drawer('toggle');
		});
	}

	// Featured Image background image
	function sm_featured_image() {
		$('.entry-background').backstretch([FeaturedImage.src], {
			duration: 3000,
			fade: 750,
			alignY: 'center',
		});
	}

	// WOW initiallizer
	function sm_front_page_animation() {
		var wow = new WOW({ mobile: false });
		wow.init();
	}

	// Set height of front-page and load backstretch image
	function sm_front_page_height() {
		var windowHeight = $(window).outerHeight();
		var newHeight = windowHeight * 0.95;

		$('.front-page-1').css({ height: newHeight + 'px' });

		$(window).on('resize', function () {
			var windowHeight = $(window).outerHeight();
			var newHeight = windowHeight * 0.95;

			$('.front-page-1').css({ height: newHeight + 'px' });
		});
	}

	// Backstretch
	function sm_front_page_backstretch() {
		$('.front-page-1').backstretch([BackStretchImg.src], {
			duration: 3000,
			fade: 750,
			alignY: 'center',
		});
	}

	// Down arrow and localScroll
	function sm_front_page_down_arrow_1() {
		$('.front-page-1 .backstretch').after(
			'<div class="down-arrow"><div class="wrap"><a href="#front-page-2" class="wow flipInX" data-wow-delay="2s"><i class="icon fas fa-long-arrow-alt-down"></i></a></div></div>'
		);
		$('.front-page').localScroll({
			duration: 1500,
			offset: -25,
		});
	}

	// Down arrow and localScroll
	function sm_front_page_down_arrow_2() {
		$('.front-page-2 .widget-area .wrap').after(
			'<div class="down-arrow"><div class="wrap"><a href="#front-page-3" class="wow flipInX" data-wow-delay=".5s"><i class="icon fas fa-long-arrow-alt-down"></i></a></div></div>'
		);
		$('.front-page').localScroll({
			duration: 1500,
			offset: -25,
		});
	}

	// Tabs for single attorney profiles
	function sm_attorney_tabs() {
		$('.single-poa_person #tabs').tabs();
	}

	// Google Maps container
	function sm_google_maps_container() {
		var windowWidth = $(window).width();
		var windowHeight = $(window).outerHeight();
		if (windowWidth > 600) {
			var newHeight = windowHeight;

			$('.contact .google-maps').css({
				height: newHeight + 'px',
				width: windowWidth + 'px',
			});

			$(window).on('resize', function () {
				var windowWidth = $(window).width();
				var windowHeight = $(window).outerHeight();
				var newHeight = windowHeight;

				$('.contact .google-maps').css({
					height: newHeight + 'px',
					width: windowWidth + 'px',
				});
			});
		} else {
			var siteHeaderHeight = $('.site-header').outerHeight();
			var siteInnerHeight = windowHeight - siteHeaderHeight;
			var oneThirdHeight = (windowHeight - siteHeaderHeight) / 2;

			$('.contact .site-inner').css({ height: siteInnerHeight + 'px' });
			$('.contact .site-inner .one-half').css({
				height: oneThirdHeight + 'px',
			});
		}
	}

	// Do maps script
	function sm_google_maps() {
		if ($('body').hasClass('contact')) {
			var street = poa_office_attached.street
				? poa_office_attached.street + ', '
				: '';
			var suite = poa_office_attached.suite
				? poa_office_attached.suite + ', '
				: '';
			var city = poa_office_attached.city
				? poa_office_attached.city + ', '
				: '';
			var state = poa_office_attached.state
				? poa_office_attached.state + ', '
				: '';
			var postal = poa_office_attached.zip
				? poa_office_attached.zip + ', '
				: '';
			var country = poa_office_attached.country
				? poa_office_attached.country
				: '';
		} else {
			var street = poa_office.street ? poa_office.street + ', ' : '';
			var suite = poa_office.suite ? poa_office.suite + ', ' : '';
			var city = poa_office.city ? poa_office.city + ', ' : '';
			var state = poa_office.state ? poa_office.state + ', ' : '';
			var postal = poa_office.zip ? poa_office.zip + ', ' : '';
			var country = poa_office.country ? poa_office.country : '';
		}

		var address = street + suite + city + state + postal + country;

		var geocoder = new google.maps.Geocoder();

		var myOptions = {
			zoom: 17,
			mapTypeControl: false,
			navigationControl: false,
			scaleControl: false,
			draggable: true,
			scrollwheel: true,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
		};

		var myStyles = [
			{
				featureType: 'all',
				stylers: [
					{
						saturation: 0,
					},
					{
						hue: '#e7ecf0',
					},
				],
			},
			{
				featureType: 'road',
				stylers: [
					{
						saturation: -70,
					},
				],
			},
			{
				featureType: 'transit',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'poi',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'water',
				stylers: [
					{
						visibility: 'simplified',
					},
					{
						saturation: -60,
					},
				],
			},
		];

		var map = new google.maps.Map(
			document.getElementById('google-maps'),
			myOptions
		);

		if (geocoder) {
			geocoder.geocode(
				{
					address: address,
				},

				function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
							map.setCenter(results[0].geometry.location);

							if ($('body').hasClass('contact')) {
								map.panBy(0, 100); // offset center of map by 100 pixels vertically
							}

							var infowindow = new google.maps.InfoWindow({
								content: '<b>' + address + '</b>',
								size: new google.maps.Size(150, 50),
							});

							var marker = new google.maps.Marker({
								position: results[0].geometry.location,
								map: map,
								title: address,
							});

							map.setOptions({ styles: myStyles });

							google.maps.event.addListener(
								marker,
								'click',
								function () {
									infowindow.open(map, marker);
								}
							);
						}
					}
				}
			);
		}
	}

	sm_body_class_js();
	sm_site_header();
	sm_drawer_menu();
	sm_drawer_nav_toggle();

	if (!$('body').hasClass('front-page') && !$('body').hasClass('contact')) {
		sm_featured_image();
	}

	if ($('body').hasClass('front-page')) {
		sm_front_page_animation();
		sm_front_page_height();
		sm_front_page_backstretch();
		sm_front_page_down_arrow_1();
		sm_front_page_down_arrow_2();
	}

	if ($('body').hasClass('single-poa_person')) {
		sm_attorney_tabs();
	}

	if ($('body').hasClass('contact')) {
		sm_google_maps_container();
	}

	if ($('body').hasClass('contact') || $('body').hasClass('front-page')) {
		google.maps.event.addDomListener(window, 'load', sm_google_maps);
	}
});
